var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDViewSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8945312,7.3291016L17.3408203,1.5527344c-0.8398438-0.4199219-1.8427734-0.4199219-2.6826172,0L3.1064453,7.3291016 C2.4238281,7.6689453,2,8.3544922,2,9.1181641v13.7636719c0,0.7636719,0.4238281,1.4492188,1.1054688,1.7890625 l11.5537109,5.7763672C15.0791016,30.6572266,15.5390625,30.7617188,16,30.7617188s0.921875-0.1044922,1.3417969-0.3144531 l11.5517578-5.7763672C29.5761719,24.3310547,30,23.6455078,30,22.8818359V9.1181641 C30,8.3544922,29.5761719,7.6689453,28.8945312,7.3291016z M15.5517578,3.3417969c0.28125-0.1416016,0.6162109-0.140625,0.8955078,0 L26.7636719,8.5L16,13.8818359L5.2363281,8.5L15.5517578,3.3417969z M4,22.8818359V10.1181641l11,5.5v12.7636719L4,22.8818359z  M17,28.3823242V15.6181641l11-5.5v12.7636719L17,28.3823242z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDViewSmall);
export default __webpack_public_path__ + "static/media/three-d-view--small.774ab3c8eff31ea45e23ebebe26f6575.svg";
export { ForwardRef as ReactComponent };